"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUUID = createUUID;
exports.batchCheckStringParameters = batchCheckStringParameters;
exports.doesUserHaveAdminAccess = doesUserHaveAdminAccess;
exports.validateRequestRolePermissions = validateRequestRolePermissions;
exports.doesCompanyHaveAddonsEnabled = doesCompanyHaveAddonsEnabled;
const uuid_1 = require("uuid");
const constants_1 = require("../constants");
const permissions_1 = require("../permissions");
function createUUID() {
    return (0, uuid_1.v4)();
}
function batchCheckStringParameters(params) {
    for (const param of params) {
        if (param === null ||
            param === undefined ||
            param === "" ||
            param.trim() === "") {
            return false;
        }
    }
    return true;
}
function doesUserHaveAdminAccess(role) {
    return role === constants_1.SystemRole.ADMIN || role === constants_1.SystemRole.SYSTEM_ADMIN;
}
function validateRequestRolePermissions(role, requireUserPermissions) {
    // No permission requirement → allow
    if (!requireUserPermissions || requireUserPermissions.length === 0) {
        return true;
    }
    // OR across groups
    return requireUserPermissions.some((permissionGroup) => 
    // AND within group
    permissionGroup.every((permission) => (0, permissions_1.hasPermission)(role, permission)));
}
function doesCompanyHaveAddonsEnabled(company, addons) {
    for (const addon of addons) {
        switch (addon) {
            case constants_1.SystemAddOn.TEST_LABEL_PRINTING:
                if (!company.enableLabelPrinting)
                    return false;
            case constants_1.SystemAddOn.CLIENT_PORTAL_INTEGRATION:
                if (!company.enableClientPortalIntegration)
                    return false;
            case constants_1.SystemAddOn.WORKFLOW_MANAGEMENT:
                if (!company.enableWorkflowManagement)
                    return false;
            case constants_1.SystemAddOn.TEMP_PASSWORD_MANAGEMENT:
                if (!company.enableTempPasswordManagement)
                    return false;
        }
    }
    return true;
}
